import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import React, { useState } from 'react';
import AKDynamicTable from './lazyLoadedTable';
var styles = css({
  alignSelf: 'normal',
  marginBottom: '0px',
  wordBreak: 'initial'
});
var Table = function Table(_ref) {
  var head = _ref.head,
    rows = _ref.rows,
    _ref$rowsPerPage = _ref.rowsPerPage,
    rowsPerPage = _ref$rowsPerPage === void 0 ? 15 : _ref$rowsPerPage;
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    currentPage = _useState2[0],
    setCurrentPage = _useState2[1];

  // rowsPerPage of 0 is a sentinel value for a fixed size Table
  var isFixedSize = rowsPerPage === 0 || rows.length <= rowsPerPage;
  rowsPerPage = isFixedSize ? Infinity : rowsPerPage;
  function onChange(i) {
    setCurrentPage(i);
  }
  return jsx("div", {
    css: styles
  }, jsx(AKDynamicTable, {
    isFixedSize: isFixedSize,
    rowsPerPage: rowsPerPage,
    page: currentPage,
    onSetPage: onChange,
    head: head,
    rows: rows
  }));
};
var TableFn = function TableFn(_ref2) {
  var props = _ref2.props,
    children = _ref2.children,
    dispatch = _ref2.dispatch,
    render = _ref2.render,
    Components = _ref2.Components;
  var _ref3 = props,
    rowsPerPage = _ref3.rowsPerPage;
  var convertRow = function convertRow(row) {
    var cells = row.children.filter(function (child) {
      return child.type === 'Cell';
    }).map(function (cell) {
      var content = cell.children.map(function (child) {
        return render({
          aux: child,
          dispatch: dispatch,
          Components: Components
        });
      });
      return {
        content: content
      };
    });
    return {
      cells: cells
    };
  };
  var head = children.filter(function (child) {
    return child.type === 'Head';
  });
  var headData = head.length > 0 ? convertRow(head[0]) : {
    cells: []
  };
  var rows = children.filter(function (child) {
    return child.type === 'Row';
  }).map(function (row) {
    return convertRow(row);
  });
  return jsx(Table, {
    head: headData,
    rows: rows,
    rowsPerPage: rowsPerPage
  });
};
export { Table, TableFn };